export const stopPropagation = (e) => {
  e.stopPropagation();
  e.stopImmediatePropagation?.();
};
